<template>
    <div>
        请上传背景图：
        <UploadImg v-if='noteState' @getPicList="getBgimg" :getList='noteObj.bg_img' message='1' id='bgi'></UploadImg>
        请上传按钮图：

        <UploadImg  v-if='noteState'  @getPicList="getBtimg" :getList='noteObj.bt_img' message='1' id='bti'></UploadImg>
        请上传gif图：

        <picturegif  v-if='noteState'  @getPicList="getGif" :getList='noteObj.gif' message='1' id='notgif'></picturegif>
        请上传音频：
        <Audio  v-if='noteState'  @getAudioList="getMp3" :getList='noteObj.mp3' message='1'></Audio>
    </div>
</template>

<script>
    import UploadImg from '../common/picture.vue'
  
    import picturegif from '../common/picturegif.vue'
    import Audio from '../common/audio.vue'
    export default {
        props: ['noteState','getNoteList'], 
        components: {
            UploadImg,
            picturegif,
            Audio,
        },
        data() {
            return {
                noteObj:{
                    bg_img:'',
                    bt_img:'',
                    gif:'',
                    mp3:'',
                },
            }
        },
        methods: {
            getBgimg(url){
                this.noteObj.bg_img='/image/'+url[0].name;
                this.$emit('getNote',this.noteObj);
            },
            getBtimg(url){
                this.noteObj.bt_img='/image/'+url[0].name;
                this.$emit('getNote',this.noteObj);


            },
            getGif(url){
                this.noteObj.gif='/image/'+url[0].name;
                this.$emit('getNote',this.noteObj);

            },
            getMp3(urls){
                 this.noteObj.mp3=urls[0].url;
                this.$emit('getNote',this.noteObj);
            },
        },
        created() {
            this.noteObj.bg_img=this.getNoteList.bg_img;
            this.noteObj.bt_img=this.getNoteList.bt_img;
            this.noteObj.gif=this.getNoteList.gif;
            this.noteObj.mp3=this.getNoteList.mp3;
        }
    }
</script>